'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Frame = require('./Frame');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Frame).default;
  }
});

var _Context = require('./Context');

Object.defineProperty(exports, 'FrameContext', {
  enumerable: true,
  get: function get() {
    return _Context.FrameContext;
  }
});
Object.defineProperty(exports, 'FrameContextConsumer', {
  enumerable: true,
  get: function get() {
    return _Context.FrameContextConsumer;
  }
});
Object.defineProperty(exports, 'useFrame', {
  enumerable: true,
  get: function get() {
    return _Context.useFrame;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}